import { MdOutlineDownload } from "react-icons/md";
import CircleActionButton from "../CircleActionButton";
import { DownloadSummaryButtonStyled } from "./styles";

const DownloadSummaryButton = ({onClick}: any) => {
  return (
    <div style={{margin: "20px auto"}}>
      <DownloadSummaryButtonStyled onClick={onClick}>
        <CircleActionButton
          label=""
          bg="#EFEFEF"
        >
          <MdOutlineDownload/>
        </CircleActionButton>
        <p>Download Summary</p>
      </DownloadSummaryButtonStyled>
    </div>
  );
}

export default DownloadSummaryButton;